import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgContentCopyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "15 14 14 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.526 16.909h-8.105a1.464 1.464 0 00-1.474 1.455v10.181A1.463 1.463 0 0019.421 30h8.105A1.464 1.464 0 0029 28.545V18.364a1.463 1.463 0 00-1.474-1.455zM25.316 14h-8.842A1.464 1.464 0 0015 15.455v10.181h1.474V15.455h8.842V14z",
    fill: "currentColor"
  })));
}

export { SvgContentCopyFilled as ReactComponent };
